import { EventbookingCommentActionTypes } from './constants';

const EVENTBOOKING_COMMENT_STATE = {
    eventbooking_comments: [],
    total_pages: 1,
    filters: { },
    loading: false,
};

type EventbookingCommentAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { eventbooking_comment?: {} | null, loading?: boolean, +value?: boolean };

const EventbookingCommentReducer = (state: State = EVENTBOOKING_COMMENT_STATE, action: EventbookingCommentAction): any => {
    switch (action.type) {
        case EventbookingCommentActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        eventbooking_comments: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        eventbooking_comments: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages || 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        eventbooking_comments: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages || 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        eventbooking_comments: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages || 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        eventbooking_comments: action.payload.data.eventbookings,
                        total_pages: action.payload.data.total_pages || 1,
                        loading: false,
                    };
                }

                default:
                    return {...state};
            }

        case EventbookingCommentActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking_comments: [],
                        total_pages: 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking_comments: [],
                        total_pages: 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking_comments: [],
                        total_pages: 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking_comments: [],
                        total_pages: 1,
                        loading: false,
                    };
                }
                case EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT: {
                    return {
                        ...state,
                        error: action.payload.error,
                        eventbooking_comments: [],
                        total_pages: 1,
                        loading: false,
                    };
                }

                default:
                    return {...state};
            }

        case EventbookingCommentActionTypes.LIST_EVENTBOOKING_COMMENT:
            return { ...state, loading: true, eventbooking_comments: [], total_pages: 1 };
        case EventbookingCommentActionTypes.UPDATE_EVENTBOOKING_COMMENT:
            return { ...state, loading: true, eventbooking_comments: [], total_pages: 1 };
        case EventbookingCommentActionTypes.CREATE_EVENTBOOKING_COMMENT:
            return { ...state, loading: true, eventbooking_comments: [], total_pages: 1 };
        case EventbookingCommentActionTypes.DELETE_EVENTBOOKING_COMMENT:
            return { ...state, loading: true, eventbooking_comments: [], total_pages: 1 };
        case EventbookingCommentActionTypes.UPDATE_MESSAGE_EVENTBOOKING_COMMENT:
            return { ...state, loading: true, eventbooking_comments: [], total_pages: 1 };
        default:
            return { ...state };
    }
};

export default EventbookingCommentReducer;